export const utilGetHighBonusLabel = (
  earnedPoints?: number,
  basePrice?: number | null,
  loyaltyLevel?: number,
  isAuthorized?: boolean
): boolean => {
  if (!earnedPoints || earnedPoints === 0 || !basePrice) {
    return false;
  }

  const bonusPercentage = Math.ceil((earnedPoints / basePrice) * 100);

  if (!isAuthorized) {
    return bonusPercentage > 25;
  }

  switch (loyaltyLevel) {
    case 1:
      return bonusPercentage > 10;
    case 2:
      return bonusPercentage > 25;
    default:
      return bonusPercentage > 25;
  }
};
